import {
  createTheme,
  TabItem as FlowbiteTabItem,
  Tabs as FlowbiteTabs,
} from 'flowbite-react';
import { ReactNode } from 'react';

export interface TabItem {
  key: string;
  title: string;
  content: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  defaultActiveKey?: string;
  onTabChange?: (key: string) => void;
  theme?: any;
}

const defaultTabsTheme = createTheme({
  tabs: {
    base: 'flex flex-col',
    tablist: {
      base: 'flex gap-4 items-center bg-white p-4 rounded-lg shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]',
      tabitem: {
        base: 'flex items-center justify-center px-4 py-2 p-0 rounded-lg text-sm font-normal leading-[1.5] first:ml-0 focus:outline-none disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500',
        variant: {
          default: {
            base: 'px-4 py-2',
            active: {
              on: 'bg-brand-purple-900 text-white',
              off: 'text-gray-500 hover:bg-gray-100 hover:text-gray-700',
            },
          },
        },
        icon: 'mr-2 h-5 w-5',
      },
    },
    tabpanel: '',
  },
}).tabs;

export const Tabs: React.FC<TabsProps> = ({
  items,
  defaultActiveKey,
  onTabChange,
  theme,
}) => {
  return (
    <FlowbiteTabs
      aria-label="Tabs"
      variant={'default'}
      theme={theme || defaultTabsTheme}
      onActiveTabChange={(tab: number) => onTabChange?.(items[tab]?.key)}
    >
      {items.map((item, index) => (
        <FlowbiteTabItem
          key={item.key}
          title={item.title}
          active={
            defaultActiveKey === item.key || (index === 0 && !defaultActiveKey)
          }
        >
          {item.content}
        </FlowbiteTabItem>
      ))}
    </FlowbiteTabs>
  );
};
